import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy text-ivory">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Foundation Info */}
          <div className="md:col-span-2">
            <h3 className="font-serif text-3xl text-gold mb-4">
              The Parker Family<br />Legacy Foundation
            </h3>
            <p className="text-ivory/80 leading-relaxed mb-6">
              A faith-anchored, legacy-driven philanthropic organization dedicated to 
              generational restoration, maternal housing, and family stabilization.
            </p>
            <p className="text-ivory/80 italic">
              "Building Legacy. Restoring Families. Sheltering Hope."
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-gold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-gold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-gold mr-3 mt-1 flex-shrink-0" />
                <span className="text-ivory/80">Baton Rouge, Louisiana</span>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 text-gold mr-3 mt-1 flex-shrink-0" />
                <a href="mailto:info@theparkerfamilylegacyfoundation.org" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  info@theparkerfamilylegacyfoundation.org
                </a>
              </li>
              <li className="flex items-start">
                <Phone className="h-5 w-5 text-gold mr-3 mt-1 flex-shrink-0" />
                <a href="tel:+12255068722" className="text-ivory/80 hover:text-gold transition-colors duration-300">
                  (225) 506-8722
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gold/30 mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center text-ivory/60 text-sm">
          <p className="mb-4 md:mb-0">
            © {new Date().getFullYear()} The Parker Family Legacy Foundation. All rights reserved.
          </p>
          <p className="flex items-center">
            Made with <Heart className="h-4 w-4 text-gold mx-2 fill-current" /> for lasting impact
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
